import { appEnvironment } from 'utils/environment';

export const getTagsSubdomain = () => {
  const tagsSubdomain = 'tags';

  switch (appEnvironment) {
    case 'prod':
    case 'production':
      return tagsSubdomain;
    case 'local':
      // Local environment should always use a pre-production tags subdomain
      return `${tagsSubdomain}-qa`;
    default:
      return `${tagsSubdomain}-${appEnvironment}`;
  }
};

export const getTagsFileUrl = (tagsFile: string) => {
  const tagsDomain = getTagsDomain();

  return `${tagsDomain}/chime-dot-com/${tagsFile}.html`;
};

export const getTagsDomain = () => {
  const tagsSubdomain = getTagsSubdomain();

  return `https://${tagsSubdomain}.chime.com`;
};
